import practiceInstructionStart from '../sounds/ln_avatar_start_practice_instruction.mp3';
import practiceInstructionActive from '../sounds/ln_correct_answer_avatar_instruction.mp3';
import practiceInstructionReady from '../sounds/ln_practice_instruction_ready_state.mp3';

export const SPELLING_AUDIO_INSTRUCTIONS = {
    practiceInstructionStart,
    practiceInstructionActive,
    practiceInstructionReady,
};

export default SPELLING_AUDIO_INSTRUCTIONS;
